import React from 'react';
import { EntityForm } from '../../../widgets/Forms';
import { CustomTextField } from '../../../widgets/CustomTextField';
import { Row, Col } from 'react-bootstrap';



export default function HETLecturerSupportSetupSearchForm(props) {

    return (
        <EntityForm ref={React.createRef()} viewId="HETLecturerSupportSetup" values={props.data}
            entityLookupController={props.entityLookupController} org="saseta"
            entityLookupId={props.id} useCustomSettings={false} valueChangeHandler={props.valueChangeHandler}>
            {form => <form className={form.classes.container} id="HETLecturerSupport" style={{ width: '600px' } }>
                <div className="row search-form-container">
                    <div className="col form-col">
                        <CustomTextField
                            id="HETLecturerSupportCode"
                            label="HET Lecturer Support Code"
                            className="w-100"
                            onKeyPress={props.onKeyUp}
                            InputProps={{
                                readOnly: false,
                            }}
                            form={form}
                        />
                    </div>
                    <div className="col form-col">
                        <CustomTextField
                            id="HETLecturerSupportTitle"
                            label="HET Lecturer Support Title"
                            className="w-100"
                            onKeyPress={props.onKeyUp}
                            InputProps={{
                                readOnly: false,
                            }}
                            form={form}
                        />
                    </div>
                </div>
            </form>
            }
        </EntityForm>
    );
}
